export class Trace {
    subscriber = null;
    setSubscriber(subscriber) {
        this.subscriber = subscriber;
        return this;
    }
    event = (event) => {
        try {
            this.subscriber?.onEvent?.(event);
        }
        catch (e) {
            console.error("[logger] subscriber.onEvent threw", e);
        }
    };
    enter = (span) => {
        try {
            this.subscriber?.onEnter?.(span);
        }
        catch (e) {
            console.error("[logger] subscriber.onEnter threw", e);
        }
        return span;
    };
    exit = (span) => {
        try {
            this.subscriber?.onExit?.(span);
        }
        catch (e) {
            console.error("[logger] subscriber.onExit threw", e);
        }
    };
}
const TRACE_KEY = Symbol.for("@artis/logger/trace");
const global = globalThis;
if (!global[TRACE_KEY])
    global[TRACE_KEY] = new Trace();
export const defaultTrace = global[TRACE_KEY];
export const setDefaultSubscriber = (subscriber) => defaultTrace.setSubscriber(subscriber);
//# sourceMappingURL=tracing.js.map